module.exports = __webpack_public_path__ + "static/img/brid_self.b753518.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/brid_self.png
// module id = FfGo
// module chunks = 1 3